import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
// Material Design Imports
import {
  MatSnackBar, MatIconRegistry, MatProgressSpinner, MatRadioModule, MatPaginator, MatPaginatorModule,
  MatCardModule, MatTabsModule, MatProgressBar, MatProgressBarModule, MatSelectModule, MatCheckboxModule, MatRippleModule
} from '@angular/material';
import { MatDialog } from '@angular/material';
import { MatToolbarModule, MatTooltipModule } from '@angular/material';
import { MatSidenavModule, MatSidenav, MatTableModule } from '@angular/material';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';
import { MatIconModule, MatButtonModule, MatButtonToggleModule } from '@angular/material';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// EuroKing Personal Health Record Imports
import { AppConfigService } from './services/app-config-service/app-config.service';
import { ShellUpdateService, ShellUpdateMessage } from './services/shell-update-service/shell-update.service';
import { PortalHeaderComponent } from './components/portal-header/portal-header.component';
import { PortalFooterComponent } from './components/portal-footer/portal-footer.component';
import { PortalLoginViewComponent } from './views/portal-login-view/portal-login-view.component';
import { PortalNotFoundViewComponent } from './views/portal-notfound-view/portal-notfound-view.component';
import { PortalWelcomeViewComponent } from './views/portal-welcome-view/portal-welcome-view.component';
import { PortalLogoutViewComponent } from './views/portal-logout-view/portal-logout-view.component';
import { AuthHttpClient } from './services/auth-http-service/auth-http.service';
import { AuthGuardService } from './services/auth-guard-service/auth-guard.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoggingService } from './services/logging-service/logging.service';
import { UserSessionService } from './services/user-session-service/user-session.service';
import { LayoutModule } from '@angular/cdk/layout';
import { PortalMyActivityViewComponent } from './views/portal-myactivity-view/portal-myactivity-view.component';
import { PortalMyBirthPlanViewComponent } from './views/portal-mybirthplan-view/portal-mybirthplan-view.component';
import { PortalMyDetailsViewComponent } from './views/portal-mydetails-view/portal-mydetails-view.component';
import { PortalContactViewComponent } from './views/portal-contact-view/portal-contact-view.component';
import { PortalAdminSearchViewComponent } from './views/portal-admin-search-view/portal-admin-search.component';
import { PortalAdminViewComponent } from './views/portal-admin-view/portal-admin.component';
import { PortalMyEpaViewComponent } from './views/portal-myepa-view/portal-myepa-view.component';
import { PortalRegistrationViewComponent } from './views/portal-registration-view/portal-registration-view.component';
import { PatientSearchService } from './services/patient-search-service/patient-search.service';
import { AuthorisationService } from './services/authorisation-service/authorisation-service.service';
import { FieldMatchDirective } from './shared/field-match.directive';
import { PatientDataService } from './services/patient-data/patient-data.service';
import { NotAvailablePipe } from './pipes/not-available-pipe.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { PortalContactAdminComponent } from './views/portal-admin-contact/portal-contact-admin/portal-contact-admin.component';
import { TrustDataService } from './services/trust-data-service/trust-data.service';
import { QuestionnaireService } from './services/questionnaire-service/questionnaire.service';
import { PortalNewPasswordComponent } from './views/portal-new-password/portal-new-password.component';
import { PortalResetPasswordComponent } from './views/portal-reset-password/portal-reset-password.component';
import { PortalHomeViewComponent } from './views/portal-home-view/portal-home-view.component';
import { PortalAdminPatientViewComponent } from './views/portal-admin-patient-view/portal-admin-patient-view.component';
import { PortalActivityViewComponent } from './views/portal-activity-view/portal-activity-view.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EmptyEmailDirective } from './directives/empty-email.directive';
import { ChangePasswordComponent } from './views/portal-change-password/change-password/change-password.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { UsefulWebsiteComponent } from './components/useful-website/useful-website.component';
import { PortalUsefulWebsiteViewComponent } from './views/portal-useful-website-view/portal-useful-website-view.component';
import { AssetService } from './services/asset-service/asset.service';
import { PortalAdminCardsViewComponent } from './views/portal-admin-cards-view/portal-admin-cards-view.component';
import { HomeCardEditorComponent } from './components/home-card-editor/home-card-editor.component';
import { DataQualityLinkComponent } from './components/data-quality-link/data-quality-link.component';
import { PortalAdminReportConfigComponent } from './views/portal-admin-report-config/portal-admin-report-config.component';
import { AddressComponent } from './components/address/address.component';
import { HomeCardService } from './services/home-card-service/home-card.service';

@NgModule({
  declarations: [
    AppComponent,
    PortalHeaderComponent,
    PortalFooterComponent,
    PortalLoginViewComponent,
    PortalNotFoundViewComponent,
    PortalWelcomeViewComponent,
    PortalLogoutViewComponent,
    PortalMyActivityViewComponent,
    PortalMyActivityViewComponent,
    PortalMyBirthPlanViewComponent,
    PortalMyDetailsViewComponent,
    PortalContactViewComponent,
    PortalMyEpaViewComponent,
    PortalAdminSearchViewComponent,
    PortalAdminViewComponent,
    PortalRegistrationViewComponent,
    FieldMatchDirective,
    NotAvailablePipe,
    PortalContactAdminComponent,
    PortalNewPasswordComponent,
    PortalResetPasswordComponent,
    PortalHomeViewComponent,
    PortalAdminPatientViewComponent,
    PortalActivityViewComponent,
    EmptyEmailDirective,
    ChangePasswordComponent,
    DateInputComponent,
    UsefulWebsiteComponent,
    PortalUsefulWebsiteViewComponent,
    PortalAdminCardsViewComponent,
    HomeCardEditorComponent,
    DataQualityLinkComponent,
    PortalAdminReportConfigComponent,
    AddressComponent
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatButtonToggleModule,
    ScrollDispatchModule,
    AppRoutingModule,
    MatToolbarModule,
    MatSidenavModule,
    MatRippleModule,
    MatRadioModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatTabsModule,
    MatTableModule,
    MatSelectModule,
    MatCardModule,
    MatPaginatorModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    HttpModule
  ],
  providers: [
    AppConfigService,
    ShellUpdateService,
    MatIconRegistry,
    AuthHttpClient,
    AuthGuardService,
    LoggingService,
    UserSessionService,
    PatientSearchService,
    AuthorisationService,
    PatientDataService,
    TrustDataService,
    QuestionnaireService,
    AssetService,
    HomeCardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts